<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{routeName}}</a>
      <div class="collapse navbar-collapse">
      </div>
      <div v-if="user.uid" >
        <img :src="user.photoURL" class="avatar border-white" width="30" height="30">
      </div>
      <div v-if="user.uid" >
        <p-button class="btn btn-primary btn-sm" @click.native="navLogOut">LogOut</p-button>
      </div>
    </div></nav>
</template>
<script>
export default {
  props: ['user'],
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    navLogOut(){
     this.$emit('navLogOut') 
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
  }
};
</script>
<style>
</style>
